RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsAdsConsumptionView = widgets.PostDetailsColumnView.extend({
        className: 'facebook-insights-post-details facebook-insights-post-details-consumptions',
        columnWidth: 12
    });


    const FbPostDetailsAdsConsumptionWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_ads_consumptions_title,
        description: RivalIQ.strings.facebook_insights_post_detail_ads_consumptions_description,
        view: FbPostDetailsAdsConsumptionView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            return [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PIE_CHART_BREAKOUT,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_PAID_CONSUMPTIONS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_insights_consumptions_metric_name
                    }),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_PAID_LINK_CLICKS',
                            'FACEBOOK_INSIGHTS_POST_PAID_PHOTO_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_ADS_PAID_VIDEO_VIEWS',
                            'FACEBOOK_INSIGHTS_POST_PAID_OTHER_CLICKS'
                        ],
                        dimensions: ['className']
                    })
                }
            ];
        },
        filter: function () {
            const me = this;

            return !me.curation.hasBoostedSpend;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_ADS_CONSUMPTION, FbPostDetailsAdsConsumptionWidget);

});
